export const videoShellCss = "vku4e0x";
export const videoHeaderCss = "vn7kxx";
export const videoHeaderCopyCss = "v1lr664r";
export const videoCloseButtonContainerCss = "v12gdct8";
export const videoMediaCss = "v1tph9eg";

/** Playing state: let Wistia’s 16:9 responsive padding size the frame so captions aren’t clipped. */
export const videoMediaPlayingCss = "v190zm4x";
export const videoPosterBackgroundCss = "vgzzb8q";
export const videoPosterContentCss = "v1hehiip";
export const videoEmailCardCss = "vzv1nbt";
export const videoEmailMessageCss = "vid560e";
export const videoEmailMessageTopCss = "vtd0exa";
export const videoEmailMessageBottomCss = "v1i51ymc";
export const videoEmailBodyCss = "v1ndeqmo";
export const videoEmailMetaRowCss = "v1y5snk5";
export const videoEmailMetaTimeCss = "v1rpth0a";
export const videoCallieMarkCss = "vrtuigx";
export const videoPlayButtonCss = "v1pc3vnn";
export const videoPlayIconCss = "vzl58yr";
export const videoPlayerCss = "v1vew12f";
export const videoFooterButtonsCss = "vyymf83";
export const smallerBorderRadiusCss = "sm0kvuq";

require("./aiChatDiscoveryVideoModalStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./aiChatDiscoveryVideoModalStyles.js");